import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

import { AuthSessionService } from './auth-session.service';

export type CartAuthPendingIntent =
  | { type: 'addToCart'; product: unknown }
  | { type: 'buyNow'; product: unknown }
  | { type: 'checkout' };

@Injectable({
  providedIn: 'root'
})
export class CartAuthGateService {

  private readonly _open$ = new BehaviorSubject<boolean>(false);
  private _pendingIntent: CartAuthPendingIntent | null = null;

  readonly open$ = this._open$.asObservable();

  constructor(
    private readonly authSession: AuthSessionService,
    private readonly router: Router
  ) {}

  get isOpen(): boolean {
    return this._open$.value;
  }

  openWithProduct(product: unknown): void {
    this._pendingIntent = { type: 'addToCart', product };
    this._open$.next(true);
  }

  openForBuyNow(product: unknown): void {
    this._pendingIntent = { type: 'buyNow', product };
    this._open$.next(true);
  }

  openForCheckout(): void {
    this._pendingIntent = { type: 'checkout' };
    this._open$.next(true);
  }

  /** Navega al checkout o solicita login en el modal de Mi Cuenta MEGA. */
  proceedToCheckout(): void {
    if (this.authSession.canAddToCart()) {
      this.router.navigate(['/shop/checkout']);
      return;
    }

    this.openForCheckout();
  }

  close(): void {
    this._pendingIntent = null;
    this._open$.next(false);
  }

  /** Cierra el modal y devuelve la acción pendiente tras login exitoso. */
  takePendingIntent(): CartAuthPendingIntent | null {
    const intent = this._pendingIntent;
    this._pendingIntent = null;
    this._open$.next(false);
    return intent;
  }
}
